export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14991.35d7e49c.jpg";